import { Instance, types } from 'mobx-state-tree';

export const Currency = types
  .model('Currency', {
    code: types.identifier,
    symbol: types.string
  })
  .views(self => ({
    get roundFactor(): number {
      return ['JPY', 'IDR'].includes(self.code) ? 0 : 2;
    },
    get displayLocale() {
      return ['JPY', 'IDR'].includes(self.code) ? 'en-' + self.code.slice(0, 2) : 'en-US';
    },
    get formatOptions(): Intl.NumberFormatOptions {
      return {
        maximumFractionDigits: this.roundFactor,
        minimumFractionDigits: this.roundFactor
      };
    }
  }))
  .actions(self => ({
    formatDisplayAmount(amount: number) {
      return (amount / 100).toLocaleString(self.displayLocale, self.formatOptions);
    },
    toDecimalAmount(amount: number) {
      return (amount / 100).toFixed(self.roundFactor);
    }
  }));

export type Currency = Instance<typeof Currency>;

export function formatCurrencyAmount(
  amount: number,
  code: string
): string {
  const isZeroDecimal = ['JPY', 'IDR'].includes(code);
  const roundFactor = isZeroDecimal ? 0 : 2;
  const locale = isZeroDecimal ? 'en-' + code.slice(0, 2) : 'en-US';

  return (amount / 100).toLocaleString(locale, {
    maximumFractionDigits: roundFactor,
    minimumFractionDigits: roundFactor
  });
}
